export default {
  cancel: '取消',
  bind: '绑定'
}